import { render, staticRenderFns } from "./RssRender.vue?vue&type=template&id=b8bc6526&scoped=true&"
import script from "./RssRender.vue?vue&type=script&lang=ts&"
export * from "./RssRender.vue?vue&type=script&lang=ts&"
import style0 from "./RssRender.vue?vue&type=style&index=0&id=b8bc6526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bc6526",
  null
  
)

export default component.exports